import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SettlementTemplate} from "../../../../shared/interface/settlement-template";
import {HttpErrorResponse} from "@angular/common/http";
import {SettlementTemplateService} from "../../../../shared/services/settlement-template.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {first} from "rxjs/operators";
import moment from "moment/moment";
import {MatDialogRef} from "@angular/material/dialog";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {ContractAddDialogComponent} from "../../../contracts/contract-add-dialog/contract-add-dialog.component";
import {AddSettlementsTemplateDialogComponent} from "../add-settlements-template-dialog/add-settlements-template-dialog.component";

export interface PeriodicElement {
  position: number;
  variable: string;
  application: string;
}
const ELEMENT_DATA: PeriodicElement[] = [
  {position: 1, variable: '## Dowolna treść  {{KWOTA}} ##',  application: 'Kwota rozliczenia z danego miesiąca rozliczeniowego per Partner'},
  {position: 2, variable: '{{MC-ROZLICZENIOWY}}',  application: 'Miesiąc rozliczeniowy'},
  {position: 3, variable: '{{ROZ!0}} Dowolna treść {{/ROZ!0}}',  application: 'Treść maila dla kwota rozliczenia mniejszej od zera ( < 0.00 )'},
  {position: 4, variable: '{{ROZ0}} Dowolna treść {{/ROZ0}}',  application: 'Treść maila dla kwoty rozliczenia równej zero ( = 0.00 )'},
  {position: 5, variable: '{{ROZ0!}} Dowolna treść {{/ROZ0!}}',  application: 'Treść maila dla kwota rozliczenia większa od zera ( > 0.00 )' },
];
@Component({
  selector: 'app-add-settlements-template',
  templateUrl: './add-settlements-template.component.html',
  styleUrls: ['./add-settlements-template.component.scss']
})
export class AddSettlementsTemplateComponent implements OnInit, OnDestroy {
  @Input() settlementTemplate: SettlementTemplate;
  @Output() closeModification: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() settlementTemplateCreated = new EventEmitter<string>();
  @Input() dialogRef?: MatDialogRef<AddSettlementsTemplateDialogComponent> = null;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '300px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Wprowadź treść email..',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      [
        'insertVideo',
      ]
    ]
  };

  templateForm: FormGroup;
  contentControl: FormControl;
  companyControl: FormControl;
  billingMonthControl: FormControl;
  copyBillingMonthControl: FormControl;
  typeOfSettlementControl: FormControl;
  contentCommissionZeroControl: FormControl;
  contentCommissionHigherControl: FormControl;
  contentCommissionLessControl: FormControl;
  currentTemplateObject: SettlementTemplate;
  copyTemplateObject: SettlementTemplate;
  processingRequest = false;
  errors: any = {};
  editor = false;
  tempDefault = '## Dowolna treść ##';
  tempAmount = '{{KWOTA}}';
  tempMC = '{{MIESIAC-ROZLICZENIOWY}}';
  tempCommissionLess = '{{ROZLICZENIE-0}}';
  tempCommissionZero = '{{ROZLICZENIE=0}}';
  tempCommissionHigher = '{{ROZLICZENIE+0}}';
  tempInitialBalance = '{{SALDO}}';
  copyDate = moment();
  validContentCopy = false;

  displayedColumns: string[] = ['variable', 'application'];
  dataSource = ELEMENT_DATA;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private settlementTemplateService: SettlementTemplateService,
    private snack: MatSnackBar,

  ) {
    const date = moment();
    date.subtract(1, 'month');
    this.billingMonthControl = fb.control(date, [Validators.required]);
    this.copyBillingMonthControl = fb.control(date);

    this.templateForm = this.fb.group({
      billingMonth:  this.billingMonthControl,
      content: this.contentControl = fb.control('', [Validators.required]),
      company: this.companyControl = fb.control('', [Validators.required]),
      typeOfSettlement: this.typeOfSettlementControl = fb.control('', [Validators.required]),
      contentCommissionZero: this.contentCommissionZeroControl = fb.control(''),
      contentCommissionHigher: this.contentCommissionHigherControl = fb.control(''),
      contentCommissionLess: this.contentCommissionLessControl = fb.control(''),
    });
  }

  ngOnInit(): void {
    // if (this.templateForm.valid){
    //   this.validContentCopy = true;
    // }
    if (!this.dialogRef) {
      this.billingMonthControl.disable();
      this.companyControl.disable();
      this.typeOfSettlementControl.disable();
    }
    if (this.settlementTemplate) {
      this.billingMonthControl.setValue('');
      this.initialize();
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    if (!this.templateForm.valid) {
      this.templateForm.markAllAsTouched();
      this.snackBar.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.settlementTemplateService.sendForm(
      this.templateForm.value, this.currentTemplateObject ? this.currentTemplateObject.uuid : null
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open('Pomyślnie zapiszano szablon', '', {
          duration: 2000,
        });
        if (!this.dialogRef) {
          this.closeModification.emit(false);
        } else {
          this.dialogRef.close();
        }
        this.processingRequest = false;
        this.initialize();
        }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.templateForm, this.errors);
        }
      });
  }

  initialize(): void {

    this.editor = true;
    if (!this.settlementTemplate){
       return;
    }
    this.settlementTemplateService.get(this.settlementTemplate.uuid)
      .subscribe((settlementTemplate: SettlementTemplate) => {
        if (settlementTemplate) {
          this.currentTemplateObject = settlementTemplate;
          const currentTemplateBillingMonth = moment(this.currentTemplateObject.billingMonth).format('YYYY-MM-DD');
          this.templateForm.reset({
            uuid: this.currentTemplateObject.uuid,
            content: this.currentTemplateObject.content,
            company: this.currentTemplateObject.company?.id,
            typeOfSettlement: this.currentTemplateObject.typeOfSettlement?.id,
            billingMonth: currentTemplateBillingMonth,
            contentCommissionZero: this.currentTemplateObject.contentCommissionZero,
            contentCommissionHigher: this.currentTemplateObject.contentCommissionHigher,
            contentCommissionLess: this.currentTemplateObject.contentCommissionLess
          });
        }
      }, (error: HttpErrorResponse) => {
        this.templateForm.reset({
          uuid: '',
          content: '',
          company: this.companyControl.value,
          typeOfSettlement: this.typeOfSettlementControl.value,
          billingMonth: this.billingMonthControl.value,
          contentCommissionZero: '',
          contentCommissionHigher: '',
          contentCommissionLess: '',
        });
        // this.snackBar.open(`Brak szablonu dla miesiąca: ${this.billingMonthControl.value.format('YYYY-MM')}`, null, {
        //   duration: 5000,
        // });
        this.currentTemplateObject = null;
      });
  }

  copy(): void {

    const activeToDate = moment(this.billingMonthControl.value);
    activeToDate.subtract(1, 'month');
    this.copyBillingMonthControl.setValue(activeToDate);

    this.contentControl.setValue(' ');
    this.contentCommissionLessControl.setValue(' ');
    this.contentCommissionHigherControl.setValue(' ');
    this.contentCommissionZeroControl.setValue(' ');
    if (!this.templateForm.valid) {
      this.templateForm.markAllAsTouched();
      this.snackBar.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.settlementTemplateService.getCurrent({
      billingMonth: this.copyBillingMonthControl.value.format('YYYY-MM'),
      company: this.companyControl.value,
      typeOfSettlement: this.typeOfSettlementControl.value
    })
      .pipe()
      .subscribe((settlementItems) => {
        settlementItems.items.forEach((copySettlementTemplate) => {

          if (copySettlementTemplate) {
            this.copyTemplateObject = copySettlementTemplate;
            this.templateForm.reset({
              content: this.copyTemplateObject.content,
              company: this.companyControl.value,
              typeOfSettlement: this.typeOfSettlementControl.value,
              billingMonth: this.billingMonthControl.value,
              contentCommissionLess: this.copyTemplateObject.contentCommissionLess,
              contentCommissionZero: this.copyTemplateObject.contentCommissionZero,
              contentCommissionHigher: this.copyTemplateObject.contentCommissionHigher,
            });
          }
        })

      }, (error: HttpErrorResponse) => {
        this.snackBar.open(`Brak szablonu dla miesiąca: ${this.copyBillingMonthControl.value.format('YYYY-MM')}`, null, {
          duration: 5000,
        });
      });

  }

  cancel(): void {
    if (!this.dialogRef) {
      this.closeModification.emit(false);
    } else {
      this.dialogRef.close();
    }
  }

  copyMessage(val: string): void{
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snack.open('Skopiowano do schowka', '', {duration: 2000});

  }


}
